import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import LandlordCommissionView from 'features/ManagePremises/components/LandlordCommissionView';
import PremiseInfoView from 'features/ManagePremises/components/PremiseInfoView';
import PremiseRentalPriceView from 'features/ManagePremises/components/PremiseRentalPriceView';
import { Formik } from 'formik';
import AppTabs from 'general/components/AppTabs';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import CustomAlert from 'general/components/Others/CustomAlert';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

function EditPremiseScreen(props) {
    // MARK: ---- PROPERTIES ----
    const { t } = useTranslation();
    const router = useRouter();
    const premiseId = router.query?.premiseId;
    const { user } = useSelector((state) => state.auth);
    const { agencyRole, isAddSubAgency = false } = props;
    const refFormik = useRef();
    const [bankList, setBankList] = useState([]);
    const [selectedTab, setSelectedTab] = useState(t('Thông tin mặt bằng'));
    const [premiseDetail, setPremiseDetail] = useState();

    const [commissionGrounds, setCommissionGrounds] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [readyToValidData, setReadyToValidData] = useState(false);

    const [selectedAreaProvince, setSelectedAreaProvince] = useState();
    const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
    const [premiseLandlordEnergyCommission, setPremiseLandlordEnergyCommission] = useState();
    const [premiseLandlordCommission, setPremiseLandlordCommission] = useState();
    const [isAdminAgency, setAdminAgency] = useState(false);
    const [saleCommission, setSaleCommission] = useState();
    const [rentalForm, setRentalForm] = useState('Có phí');

    const [isRentalPriceTypeDisabled, setRentalPriceTypeDisabled] = useState(true);

    const isDisabled = useMemo(() => {
        if (
            selectedTab === t('Hoa hồng giới thiệu mặt bằng') &&
            (!premiseDetail || !premiseDetail?.sales?.length)
        ) {
            return true;
        }
        return false;
    }, [selectedTab, premiseDetail]);

    useEffect(() => {
        if (premiseDetail) {
            setRentalForm(handleGetRentingForm(premiseDetail));
            if (premiseDetail?.chargeStations?.length) setRentalPriceTypeDisabled(false);
        }
    }, [premiseDetail])

    const appConfig = useAppConfig();
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    useEffect(() => {
        setCommissionGrounds(
            appConfig.commissionRateLandlord
                ? JSON.parse(appConfig.commissionRateLandlord)
                    .map(item => ({
                        key: item.key,
                        name: item.name,
                        value: item?.value ?? 0,
                        car: item?.car ?? 0,
                        bike: item?.bike ?? 0,
                        show: item.show
                    }))
                : [{ name: '', value: 0, car: 0, bike: 0 }]
        );
    }, [appConfig]);

    useEffect(() => {
        if (premiseId) handleGetPremiseDetail(premiseId);
        else setIsReady(true);
    }, [premiseId]);

    useEffect(() => {
        const saleCommission = premiseDetail?.agency?.commissions?.length > 0
            ? premiseDetail.agency.commissions.find((item) => item?.role === 'SALE' && !item?.stationId)
            : [];
        setSaleCommission(saleCommission);
    }, [premiseDetail])

    const tabs = useMemo(() => {
        if (rentalForm === 'Miễn phí') {
            return [
                t('Thông tin mặt bằng'),
                t('Hoa hồng giới thiệu mặt bằng'),
            ].reverse();
        } else if (isAdminAgency || !saleCommission?.landlordCommission?.length) {
            return [
                t('Thông tin mặt bằng'),
                t('Phí thuê mặt bằng'),
            ].reverse();
        }
        else {
            return [
                t('Thông tin mặt bằng'),
                t('Phí thuê mặt bằng'),
                t('Hoa hồng giới thiệu mặt bằng'),
            ].reverse();
        }
    }, [rentalForm, isAdminAgency, saleCommission]);

    const disabledTabs = useMemo(() => {
        if (rentalForm === 'Miễn phí') {
            return ['Phí thuê mặt bằng'];
        }
        return [];
    }, [rentalForm]);

    // MARK: ---- METHODS ----

    const handleGetPremiseDetail = (id) => {
        AgencyHelper.API.requestGetPremiseDetail(id).then((data) => {
            if (data && Object.keys(data)?.length > 0) {
                setPremiseDetail(data);
                if (Utils.isValid(data?.agencyId)) {
                    handleGetAgencyDetail(data?.agencyId);
                } else {
                    setIsReady(true);
                }
                const tmpPremiseLandlordEnergyCommission = data?.landlord?.commissions?.find(commission =>
                    commission?.role === 'LANDLORD' &&
                    Array.isArray(data?.chargeStations) &&
                    data.chargeStations.some(station => station?.stationId === commission?.stationId)
                ) || null;
                setPremiseLandlordEnergyCommission(tmpPremiseLandlordEnergyCommission);
                const tmpPremiseLandlordCommission = data?.agency?.commissions?.find(commission =>
                    commission?.role === 'SALE' &&
                    Array.isArray(data?.chargeStations) &&
                    data.chargeStations.some(station => station?.stationId === commission?.stationId)
                ) || null;
                setPremiseLandlordCommission(tmpPremiseLandlordCommission);
            }
        });
    };

    const handleGetAgencyDetail = (id) => {
        AgencyHelper.API.requestAgencyDetail(id).then((res) => {
            if (Utils.isValid(res)) {
                setAdminAgency(!res?.parentAgencyId);
                setIsReady(true);
            }
        });
    }

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) {
            return;
        }
        setSelectedTab(newTab);
    };

    const handleClose = () => {
        router.navigate(-1);
    };

    async function handleLandlordCommission(premiseDetail, values, isNewPremise = false) {
        let isSuccessCommission = true;
        const landlordCommission = premiseDetail?.landlord?.commissions?.filter(
            (commission) => commission?.role === 'LANDLORD'
        ) || [];

        const commissionData = {
            operatorId: 1,
            agencyId: values.landlord?.agencyId || null,
            role: 'LANDLORD',
            energyCommissionMode: 'FIXED_PER_KWH',
            energyCommissionValue: (rentalForm === 'Miễn phí' || values.rentalPriceType === 'Phí thuê cố định') ? 0 : Number(values.energyCommissionValue) || 0,
            energyCommissionDuration: null,
            serviceCommission: 0,
            saleCommission: [],
            packageCommission: [],
            landlordCommission: [],
        };

        if (values?.stationCode?.length > 0) {
            for (const station of values.stationCode) {
                const matchingCommission = landlordCommission.find(
                    (commission) => commission?.stationId === station?.stationId
                );
                const data = { ...commissionData, stationId: station?.stationId };
                if (isNewPremise) {
                    if (matchingCommission && !matchingCommission.stationId) {
                        isSuccessCommission = await DealerHelper.callApiUpdateAgencyCommission(
                            matchingCommission.commissionId,
                            Utils.transformEmptyStrings(data)
                        );
                    } else {
                        isSuccessCommission = await DealerHelper.callApiCreateAgencyCommission(
                            Utils.transformEmptyStrings(data)
                        );
                    }
                } else {
                    if (matchingCommission) {
                        if (rentalForm === 'Miễn phí' || values.rentalPriceType === 'Phí thuê cố định') {
                            isSuccessCommission = await DealerHelper.callApiDeleteAgencyCommission(
                                matchingCommission.commissionId,
                            );
                        } else {
                            if (Number(matchingCommission.energyCommissionValue) !== Number(commissionData.energyCommissionValue)) {
                                isSuccessCommission = await DealerHelper.callApiUpdateAgencyCommission(
                                    matchingCommission.commissionId,
                                    Utils.transformEmptyStrings(data)
                                );
                            }
                        }
                    } else {
                        if (rentalForm !== 'Miễn phí' && values.rentalPriceType !== 'Phí thuê cố định') {
                            isSuccessCommission = await DealerHelper.callApiCreateAgencyCommission(
                                Utils.transformEmptyStrings(data)
                            );
                        }
                    }
                }

                if (!isSuccessCommission) break;
            }
        } else if (values.energyCommissionValue) {
            if (landlordCommission.length > 0) {
                isSuccessCommission = await DealerHelper.callApiUpdateAgencyCommission(
                    landlordCommission[0].commissionId,
                    Utils.transformEmptyStrings(commissionData)
                );
            } else {
                isSuccessCommission = await DealerHelper.callApiCreateAgencyCommission(
                    Utils.transformEmptyStrings(commissionData)
                );
            }
        }

        return isSuccessCommission;
    }

    // async function handleSaleCommission(premiseDetail, values, commissionGrounds) {
    //     if (!premiseDetail?.agencyId) return true;
    //     let isSuccessSaleCommission = true;
    //     const saleCommission = premiseDetail?.agency?.commissions?.filter(
    //         (commission) => commission?.role === 'SALE'
    //     ) || [];
    //     const landlordCommissionDefault = commissionGrounds.find(commission => commission?.key === values?.type);

    //     if (values?.stationCode?.length > 0) {
    //         for (let i = 0; i < values.stationCode.length; i++) {
    //             const station = values.stationCode[i];
    //             let isSuccessSaleCommission = true;

    //             const matchingCommission = saleCommission.find(
    //                 (commission) => commission?.stationId === station?.stationId
    //             );

    //             const landlordCommissionSale = matchingCommission?.landlordCommission?.[0] || {};

    //             const parsedLandlordCommissionSale = typeof landlordCommissionSale === 'string'
    //                 ? JSON.parse(landlordCommissionSale)
    //                 : landlordCommissionSale || {};

    //             // const paramCommissionLandlord = {
    //             //     key: landlordCommissionDefault?.key || parsedLandlordCommissionSale?.key,
    //             //     name: landlordCommissionDefault?.name || parsedLandlordCommissionSale?.name,
    //             //     show: landlordCommissionDefault?.show !== null ? landlordCommissionDefault?.show : parsedLandlordCommissionSale?.show,
    //             //     ...(landlordCommissionDefault?.show !== null
    //             //         ? {
    //             //             ...(values.fixEnergyCommissionValueByCar && Number(values.fixEnergyCommissionValueByCar)
    //             //                 ? { car: Number(values.fixEnergyCommissionValueByCar) }
    //             //                 : {}),
    //             //             ...(values.fixEnergyCommissionValueByBike && Number(values.fixEnergyCommissionValueByBike)
    //             //                 ? { bike: Number(values.fixEnergyCommissionValueByBike) }
    //             //                 : {}),
    //             //         }
    //             //         : {
    //             //             ...(values.fixEnergyCommissionValueLandlord && Number(values.fixEnergyCommissionValueLandlord)
    //             //                 ? { value: Number(values.fixEnergyCommissionValueLandlord) }
    //             //                 : {}),
    //             //         }),
    //             // };

    //             const commissionData = {
    //                 operatorId: 1,
    //                 agencyId: premiseDetail?.agencyId || null,
    //                 role: 'SALE',
    //                 energyCommissionMode: 'FIXED_PER_KWH',
    //                 energyCommissionValue: values.landlordCommissionType === 'Hoa hồng cố định' ? 0 : Number(values.landlordEnergyCommissionValue) || 0,
    //                 energyCommissionDuration: values.landlordCommissionType === 'Hoa hồng cố định' ? 0 : Number(values.commissionDuration) || 0,
    //                 serviceCommission: 0,
    //                 saleCommission: [],
    //                 packageCommission: [],
    //                 // landlordCommission: values.landlordCommissionType === 'Hoa hồng theo doanh thu điện' ? [] : [paramCommissionLandlord],
    //                 landlordCommission: [],
    //                 stationId: station?.stationId,
    //             };

    //             if (matchingCommission) {
    //                 if (values.landlordCommissionType === 'Hoa hồng cố định') {
    //                     isSuccessSaleCommission = await DealerHelper.callApiDeleteAgencyCommission(
    //                         matchingCommission.commissionId,
    //                     );
    //                 } else {
    //                     if (
    //                         matchingCommission.energyCommissionValue !== commissionData.energyCommissionValue ||
    //                         matchingCommission.energyCommissionDuration !== commissionData.energyCommissionDuration ||
    //                         !_.isEqual(landlordCommissionSale, commissionData.landlordCommission[0])
    //                     ) {
    //                         isSuccessSaleCommission = await DealerHelper.callApiUpdateAgencyCommission(
    //                             matchingCommission.commissionId,
    //                             Utils.transformEmptyStrings(commissionData)
    //                         );
    //                     }
    //                 }
    //             } else {
    //                 if (values.landlordCommissionType !== 'Hoa hồng cố định') {
    //                     isSuccessSaleCommission = await DealerHelper.callApiCreateAgencyCommission(
    //                         Utils.transformEmptyStrings(commissionData)
    //                     );
    //                 }
    //             }

    //             if (!isSuccessSaleCommission) {
    //                 break;
    //             }
    //         }
    //     }

    //     return isSuccessSaleCommission;
    // }

    async function handleAgencySale(premiseDetail, values, commissionGrounds) {
        if (!premiseDetail?.agencyId) return true;
        let isSuccessAgencySale = true;
        const paramUpdateSale = {
            amount: premiseDetail?.sales[0]?.amount,
            premiseType: premiseDetail?.sales[0]?.premiseType,
        };
        if (values.landlordCommissionType === 'Hoa hồng theo doanh thu điện') {
            paramUpdateSale.amount = 0;
            paramUpdateSale.premiseType = null;
        } else {
            const selectedPremiseType = commissionGrounds?.find(commission => commission?.key === values?.type);
            paramUpdateSale.amount = !selectedPremiseType?.show
                ? values.fixEnergyCommissionValueLandlord
                : (values.vehicleTypes.includes('CAR') && values.vehicleTypes.includes('BIKE')
                    ? Number(values?.fixEnergyCommissionValueByCar) + Number(values?.fixEnergyCommissionValueByBike)
                    : values.vehicleTypes.includes('CAR')
                        ? Number(values?.fixEnergyCommissionValueByCar)
                        : Number(values?.fixEnergyCommissionValueByBike));
            paramUpdateSale.premiseType = {
                key: selectedPremiseType?.key,
                name: selectedPremiseType?.name,
                ...(selectedPremiseType?.show === 0
                    ? { value: Number(values.fixEnergyCommissionValueLandlord) }
                    : { car: Number(values?.fixEnergyCommissionValueByCar), bike: Number(values?.fixEnergyCommissionValueByBike) })
            };

        }
        isSuccessAgencySale = await AgencyHelper.API.requestUpdateSale(premiseDetail?.sales[0]?.saleId, paramUpdateSale);
        return isSuccessAgencySale;
    }

    async function handleChargeStations(premiseDetail, values) {
        let isSuccessStation = true;

        if (values?.stationCode?.length > 0) {
            const stationCodeIds = values.stationCode.map(station => station?.stationId).filter(id => id);
            const chargeStations = premiseDetail?.chargeStations?.map(station => station?.stationId) || [];

            for (const stationId of stationCodeIds) {
                if (!chargeStations.includes(stationId)) {
                    isSuccessStation = await ChargeHelper.API.requestUpdateChargeStation(
                        stationId,
                        Utils.transformEmptyStrings({
                            premiseId: premiseDetail?.premiseId
                        })
                    );
                    if (!isSuccessStation) break;
                }
            }

            for (const stationId of chargeStations) {
                if (!stationCodeIds.includes(stationId)) {
                    const success = await ChargeHelper.API.requestUpdateChargeStation(
                        stationId,
                        Utils.transformEmptyStrings({
                            premiseId: null
                        })
                    );
                    if (!success) {
                        isSuccessStation = false;
                        break;
                    }
                }
            }
        } else {
            const chargeStations = premiseDetail?.chargeStations?.map(station => station?.stationId) || [];
            for (const stationId of chargeStations) {
                const success = await ChargeHelper.API.requestUpdateChargeStation(
                    stationId,
                    Utils.transformEmptyStrings({
                        premiseId: null
                    })
                );
                if (!success) {
                    isSuccessStation = false;
                    break;
                }
            }
        }

        return isSuccessStation;
    }

    async function handlePremise(values, premiseDetail) {
        const premiseData = Utils.transformEmptyStrings({
            name: values.name,
            type: values.type,
            floorArea: values.floorArea,
            vehicleTypes: values.vehicleTypes?.split(','),
            parkingSlots: values.parkingSlots,
            rentingType: values.rentingType,
            areaId: values.areaId,
            address: values.address,
            description: values.description,
            landlordId: values.landlord?.agencyId,
            saleId: values.saleId,
            fullfillmentDate: (rentalForm === 'Miễn phí' || values.rentalPriceType === 'Chia sẻ doanh thu điện') ? '' : values.startDate,
            monthlyRent: (rentalForm === 'Miễn phí' || values.rentalPriceType === 'Chia sẻ doanh thu điện') ? 0
                : values.rentingType === 'FULL'
                    ? Number(values.fixEnergyCommissionValue) ?? 0
                    : (values.fixEnergyCommissionValue * values.parkingSlots) ?? 0,
            slotRent: (rentalForm === 'Miễn phí' || values.rentalPriceType === 'Chia sẻ doanh thu điện') ? 0 :
                values.rentingType === 'FULL'
                    ? null
                    : Number(values.fixEnergyCommissionValue) ?? 0,
            saleEnergyCommissionValue: values.landlordCommissionType === 'Hoa hồng cố định' ? 0 : Number(values.landlordEnergyCommissionValue) || 0,
            saleEnergyCommissionDuration: values.landlordCommissionType === 'Hoa hồng cố định' ? 0 : Number(values.commissionDuration) || 0,
        });

        if (premiseDetail) {
            const initialPremiseData = Utils.transformEmptyStrings({
                name: premiseDetail?.name ?? '',
                type: !!premiseId ? premiseDetail?.type : {},
                floorArea: premiseDetail?.floorArea ?? '',
                vehicleTypes: premiseDetail?.vehicleTypes ?? [],
                parkingSlots: premiseDetail?.parkingSlots ?? 0,
                rentingType: premiseDetail?.rentingType ?? 'FULL',
                areaId: premiseDetail?.areaId ?? null,
                address: premiseDetail?.address ?? '',
                description: premiseDetail?.description ?? '',
                landlordId: premiseDetail?.landlord?.agencyId ?? '',
                saleId: premiseDetail?.sales[0]?.saleId ?? '',
                fullfillmentDate: premiseDetail?.fullfillmentDate ?? '',
                monthlyRent: premiseDetail?.monthlyRent ?? '',
                slotRent: premiseDetail?.slotRent ?? '',
                saleEnergyCommissionValue: premiseDetail?.saleEnergyCommissionValue ?? 0,
                saleEnergyCommissionDuration: premiseDetail?.saleEnergyCommissionDuration ?? 0,
            });

            const isPremiseDataChange = !_.isEqual(initialPremiseData, premiseData);
            if (isPremiseDataChange) {
                return await AgencyHelper.API.requestUpdatePremise(premiseDetail.premiseId, premiseData);
            } else {
                return true;
            }
        } else {
            premiseData.status = 'AVAILABLE';
            return await AgencyHelper.API.requestCreatePremise(premiseData);
        }
    }

    function handleFormErrors(errors, selectedTab, t) {
        const tabs = {
            premiseInfo: [t('Phí thuê mặt bằng'), t('Hoa hồng giới thiệu mặt bằng')],
            rentalPrice: [t('Thông tin mặt bằng'), t('Hoa hồng giới thiệu mặt bằng')],
            commission: [t('Thông tin mặt bằng'), t('Phí thuê mặt bằng')]
        };

        const errorMessages = {
            premiseInfo: [
                'name', 'type', 'floorArea', 'vehicleTypes', 'parkingSlots',
                'rentingType', 'areaId', 'address', 'description', 'landlord', 'stationCode'
            ],
            rentalPrice: ['rentalPriceType', 'energyCommissionValue', 'fixEnergyCommissionValue', 'startDate'],
            commission: [
                'landlordCommissionType', 'landlordEnergyCommissionValue', 'commissionDuration',
                'fixEnergyCommissionValueLandlord', 'fixEnergyCommissionValueByCar', 'fixEnergyCommissionValueByBike'
            ]
        };

        if (tabs.premiseInfo.includes(selectedTab) && errorMessages.premiseInfo.some(field => errors[field])) {
            ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Thông tin mặt bằng')}`);
        }
        if (tabs.rentalPrice.includes(selectedTab) && errorMessages.rentalPrice.some(field => errors[field])) {
            ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Phí thuê mặt bằng')}`);
        }
        if (tabs.commission.includes(selectedTab) && errorMessages.commission.some(field => errors[field])) {
            ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng giới thiệu mặt bằng')}`);
        }
    }

    const handleSubmit = async () => {
        refFormik.current?.handleSubmit();
        setReadyToValidData(true);
        const errors = await refFormik.current?.validateForm();
        console.log({ errors });
        const values = refFormik.current?.values;

        if (Object.keys(errors)?.length > 0) {
            handleFormErrors(errors, selectedTab, t);
            return;
        }

        if (!selectedAreaProvince || !selectedAreaDistrict) {
            ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Thông tin mặt bằng')}`);
            return;
        }

        let premiseDetailLocal = premiseDetail;
        let isNewPremise = false;
        let hasSaleOrder = premiseDetail?.agencyId;

        if (!premiseDetailLocal) {
            const res = await handlePremise(values, null);
            if (!res) return;
            premiseDetailLocal = await AgencyHelper.API.requestGetPremiseDetail(res?.premiseId);
            isNewPremise = true;
        }

        if (premiseDetailLocal?.landlord) {
            const isSuccessCommission = await handleLandlordCommission(premiseDetailLocal, values, isNewPremise);
            const isSuccessSaleCommission = isNewPremise
                ? true
                : !hasSaleOrder
                    ? true
                    : Promise.all([
                        // handleSaleCommission(premiseDetailLocal, values, commissionGrounds),
                        handleAgencySale(premiseDetailLocal, values, commissionGrounds)
                    ]).then(([saleResult, agencyResult]) => saleResult && agencyResult);
            const isSuccessStation = await handleChargeStations(premiseDetailLocal, values);

            if (isSuccessCommission && isSuccessSaleCommission && isSuccessStation) {
                if (!isNewPremise) {
                    const res = await handlePremise(values, premiseDetailLocal);
                    if (res) {
                        ToastHelper.showSuccess('Cập nhật thông tin mặt bằng thành công');
                        handleClose();
                        setTimeout(() => {
                            handleGetPremiseDetail(premiseDetail?.premiseId);
                        }, 200);
                    }
                } else {
                    ToastHelper.showSuccess('Tạo mặt bằng thành công');
                    handleClose();
                }
            }
        }
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required(t('Vui lòng nhập tên mặt bằng'))
            .test('not-empty', t('Tên mặt bằng không được chỉ chứa khoảng trắng'), (value) =>
                value ? value.trim().length > 0 : false
            ),

        type: Yup.string().required(t('Vui lòng chọn loại mặt bằng')),

        floorArea: Yup.number()
            .required(t('Vui lòng nhập diện tích mặt bằng'))
            .min(0, t('Diện tích mặt bằng phải lớn hơn hoặc bằng 0')),

        vehicleTypes: Yup.string().required(t('Vui lòng chọn loại phương tiện')),

        parkingSlots: Yup.number()
            .when(['vehicleTypes', 'rentingType'], {
                is: (vehicleTypes, rentingType) =>
                    vehicleTypes?.split(',').includes('CAR') && rentingType === 'SLOT',
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập số chỗ đỗ ô tô'))
                        .positive(t('Số chỗ đỗ ô tô phải lớn hơn 0'))
                        .integer(t('Số chỗ đỗ ô tô phải là số nguyên')),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        address: Yup.string().required(t('Vui lòng nhập địa chỉ cụ thể')),

        landlord: Yup.object().required(t('Vui lòng chọn chủ mặt bằng')),

        energyCommissionValue: Yup.string()
            .when(['rentalForm', 'rentalPriceType'], {
                is: (rentalForm, rentalPriceType) => rentalForm === 'Có phí' && (rentalPriceType === 'Chi phí thuê kết hợp' || rentalPriceType === 'Chia sẻ doanh thu điện'),
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng năng lượng'))
                        .test('is-valid-number', t('Giá trị hoa hồng năng lượng phải lớn hơn 0'), (value) =>
                            value ? !isNaN(Number(value)) && Number(value) > 0 : false
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        fixEnergyCommissionValue: Yup.string()
            .when(['rentalForm', 'rentalPriceType'], {
                is: (rentalForm, rentalPriceType) => rentalForm === 'Có phí' && (rentalPriceType === 'Chi phí thuê kết hợp' || rentalPriceType === 'Phí thuê cố định'),
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng cố định'))
                        .test('is-valid-number', t('Giá trị hoa hồng cố định phải lớn hơn 0'), (value) =>
                            value ? !isNaN(Number(value)) && Number(value) > 0 : false
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        startDate: Yup.string()
            .when(['rentalForm', 'rentalPriceType'], {
                is: (rentalForm, rentalPriceType) => rentalForm === 'Có phí' && (rentalPriceType === 'Chi phí thuê kết hợp' || rentalPriceType === 'Phí thuê cố định'),
                then: (schema) => schema.required(t('Vui lòng nhập ngày bắt đầu')),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        hasSaleOrder: Yup.bool(),

        stationCode: Yup.array()
            .when('hasSaleOrder', {
                is: (hasSaleOrder) => hasSaleOrder === true,
                then: (schema) =>
                    schema
                        .min(1, t('Vui lòng chọn ít nhất một trạm'))
                        .required(t('Vui lòng chọn trạm')),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        landlordEnergyCommissionValue: Yup.string()
            .when(['hasSaleOrder', 'landlordCommissionType', 'isAdminAgency'], {
                is: (hasSaleOrder, landlordCommissionType) =>
                    hasSaleOrder &&
                    (landlordCommissionType === 'Hoa hồng kết hợp' || landlordCommissionType === 'Hoa hồng theo doanh thu điện'),
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng năng lượng của chủ mặt bằng'))
                        .test(
                            'is-valid-number',
                            t('Giá trị hoa hồng phải là số hợp lệ'),
                            function (value) {
                                const { isAdminAgency } = this.parent;
                                if (!value) return false;
                                if (isNaN(Number(value))) return false;

                                const num = Number(value);
                                return isAdminAgency ? num >= 0 : num > 0;
                            }
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        commissionDuration: Yup.string()
            .when(['hasSaleOrder', 'landlordCommissionType', 'isAdminAgency'], {
                is: (hasSaleOrder, landlordCommissionType) =>
                    hasSaleOrder &&
                    (landlordCommissionType === 'Hoa hồng kết hợp' || landlordCommissionType === 'Hoa hồng theo doanh thu điện'),
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập thời hạn hoa hồng'))
                        .test(
                            'is-valid-number',
                            t('Thời gian áp dụng phải lớn hơn 0'),
                            function (value) {
                                const { isAdminAgency } = this.parent;
                                if (!value) return false;
                                if (isNaN(Number(value))) return false;

                                const num = Number(value);
                                return isAdminAgency ? num >= 0 : num > 0;
                            }
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        fixEnergyCommissionValueLandlord: Yup.string()
            .when(['type', 'hasSaleOrder', 'landlordCommissionType', 'isAdminAgency'], {
                is: (type, hasSaleOrder, landlordCommissionType) => {
                    const commission = Array.isArray(commissionGrounds)
                        ? commissionGrounds.find((commission) => commission?.key === type)
                        : null;
                    return !commission?.show && hasSaleOrder &&
                        (landlordCommissionType === 'Hoa hồng kết hợp' || landlordCommissionType === 'Hoa hồng cố định')
                },
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng cố định cho chủ mặt bằng'))
                        .test(
                            'is-valid-number',
                            t('Giá trị hoa hồng phải là số dương'),
                            function (value) {
                                const { isAdminAgency } = this.parent;
                                if (!value) return false;
                                if (isNaN(Number(value))) return false;

                                const num = Number(value);
                                return num >= 0;
                            }
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        fixEnergyCommissionValueByCar: Yup.string()
            .when(['type', 'hasSaleOrder', 'landlordCommissionType', 'isAdminAgency'], {
                is: (type, hasSaleOrder, landlordCommissionType) => {
                    const commission = Array.isArray(commissionGrounds)
                        ? commissionGrounds.find((commission) => commission?.key === type)
                        : null;
                    return !!commission?.show && hasSaleOrder &&
                        (landlordCommissionType === 'Hoa hồng kết hợp' || landlordCommissionType === 'Hoa hồng cố định')
                },
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng cố định cho ô tô'))
                        .test(
                            'is-valid-number',
                            t('Giá trị hoa hồng phải là số dương'),
                            function (value) {
                                const { isAdminAgency } = this.parent;
                                if (!value) return false;
                                if (isNaN(Number(value))) return false;

                                const num = Number(value);
                                return num >= 0;
                            }
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        fixEnergyCommissionValueByBike: Yup.string()
            .when(['type', 'hasSaleOrder', 'landlordCommissionType', 'isAdminAgency'], {
                is: (type, hasSaleOrder, landlordCommissionType) => {
                    const commission = Array.isArray(commissionGrounds)
                        ? commissionGrounds.find((commission) => commission?.key === type)
                        : null;
                    return !!commission?.show && hasSaleOrder &&
                        (landlordCommissionType === 'Hoa hồng kết hợp' || landlordCommissionType === 'Hoa hồng cố định')
                },
                then: (schema) =>
                    schema
                        .required(t('Vui lòng nhập giá trị hoa hồng cố định cho xe máy'))
                        .test(
                            'is-valid-number',
                            t('Giá trị hoa hồng phải là số dương'),
                            function (value) {
                                const { isAdminAgency } = this.parent;
                                if (!value) return false;
                                if (isNaN(Number(value))) return false;

                                const num = Number(value);
                                return num >= 0;
                            }
                        ),
                otherwise: (schema) => schema.notRequired().nullable(),
            }),

        landlordCommissionType: Yup.string().nullable(),
        isAdminAgency: Yup.boolean(),
    });

    const handleGetRentingForm = (row) => {
        const landlordCommission = row?.landlord?.commissions?.find(
            (commission) => commission?.role === 'LANDLORD'
                && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        );
        if (!row) return 'Không xác định';

        const hasMonthlyRent = row.monthlyRent > 0;
        const hasLandlordCommission = !!landlordCommission;

        if (!hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Miễn phí';
        if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';
        if (hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Có phí';
        if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';

        return 'Không xác định';
    };

    const handleGetRentingCost = (row) => {
        const landlordCommission = row?.landlord?.commissions?.find(
            (commission) => commission?.role === 'LANDLORD'
                && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        );

        if (!row) return 'Không xác định';

        const hasMonthlyRent = row.monthlyRent > 0;
        const hasLandlordCommission = !!landlordCommission;

        if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chia sẻ doanh thu điện';
        if (hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Phí thuê cố định';
        if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chi phí thuê kết hợp';

        return 'Phí thuê cố định';
    };

    const handleGetLandlordCommissionType = (row) => {
        if (!row) return 'Không xác định';

        // const landlordCommission = row?.agency?.commissions?.find(
        //     (commission) =>
        //         commission?.role === 'SALE' &&
        //         row?.chargeStations?.length &&
        //         row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        // );

        // if (!landlordCommission) return 'Hoa hồng cố định';

        // const { energyCommissionValue, energyCommissionDuration } = landlordCommission || {};
        const hasFixedCommission = row?.sales[0]?.amount > 0;
        if (hasFixedCommission && premiseDetail?.saleEnergyCommissionValue === 0 && premiseDetail?.saleEnergyCommissionDuration === 0) {
            return 'Hoa hồng cố định';
        }
        if (!hasFixedCommission && premiseDetail?.saleEnergyCommissionValue > 0 && premiseDetail?.saleEnergyCommissionDuration > 0) {
            return 'Hoa hồng theo doanh thu điện';
        }
        if (hasFixedCommission && premiseDetail?.saleEnergyCommissionValue > 0 && premiseDetail?.saleEnergyCommissionDuration > 0) {
            return 'Hoa hồng kết hợp';
        }
        return 'Hoa hồng cố định';
    };

    const premiseInfoInitial = {
        name: premiseDetail?.name ?? '',
        type: !!premiseId ? premiseDetail?.type : '',
        floorArea: premiseDetail?.floorArea ?? 0,
        vehicleTypes: premiseDetail?.vehicleTypes?.join(',') ?? '',
        parkingSlots: premiseDetail?.parkingSlots ?? 0,
        rentingType: premiseDetail?.rentingType ?? 'FULL',
        rentalForm: premiseDetail ? handleGetRentingForm(premiseDetail) : 'Có phí',
        areaId: premiseDetail?.areaId ?? null,
        address: premiseDetail?.address ?? '',
        description: premiseDetail?.description ?? '',
        landlord: premiseDetail?.landlord ?? '',
        stationCode: premiseDetail?.chargeStations ?? [],
        saleId: premiseDetail?.sales[0]?.saleId ?? '',
    }

    // const premiseLandlordEnergyCommission = useMemo(() => {
    //     return premiseDetail?.landlord?.commissions?.find(commission =>
    //         commission?.role === 'LANDLORD' &&
    //         Array.isArray(premiseDetail?.chargeStations) &&
    //         premiseDetail.chargeStations.some(station => station?.stationId === commission?.stationId)
    //     ) || null;
    // }, [premiseDetail]);

    const premiseRentalPriceInitial = {
        rentalPriceType: premiseDetail ? handleGetRentingCost(premiseDetail) : 'Phí thuê cố định',
        energyCommissionValue: premiseLandlordEnergyCommission?.energyCommissionValue ?? '',
        fixEnergyCommissionValue: premiseDetail?.rentingType === 'FULL' ? premiseDetail?.monthlyRent ?? '' : premiseDetail?.slotRent ?? '',
        startDate: premiseDetail?.fullfillmentDate ?? '',
    }

    // const premiseLandlordCommission = useMemo(() => {
    //     return premiseDetail?.agency?.commissions?.find(commission =>
    //         commission?.role === 'SALE' &&
    //         Array.isArray(premiseDetail?.chargeStations) &&
    //         premiseDetail.chargeStations.some(station => station?.stationId === commission?.stationId)
    //     ) || null;
    // }, [premiseDetail]);

    const handleGetFixEnergyCommission = (key, premiseLandlordCommission, premiseDetail) => {
        if (!premiseDetail?.agencyId) return '';
        let landlordCommissionObj = premiseLandlordCommission?.landlordCommission?.length && premiseLandlordCommission?.landlordCommission[0];

        if (landlordCommissionObj && landlordCommissionObj[key] !== undefined) {
            return landlordCommissionObj[key];
        }
        const fallbackCommission = commissionGrounds.find(
            (commission) => commission?.key === premiseDetail?.type
        );
        return fallbackCommission?.[key] ?? '';
    };

    const landlordCommissionInitial = {
        landlordCommissionType: premiseDetail?.agencyId ? handleGetLandlordCommissionType(premiseDetail) : 'Hoa hồng kết hợp',
        landlordEnergyCommissionValue: isAdminAgency ? 0 : premiseDetail?.saleEnergyCommissionValue ?? '',
        commissionDuration: isAdminAgency ? 0 : premiseDetail?.saleEnergyCommissionDuration ?? '',
        fixEnergyCommissionValueLandlord: isAdminAgency ? 0 : premiseDetail?.sales[0]?.premiseType?.value ?? 0,
        fixEnergyCommissionValueByCar: isAdminAgency ? 0 : premiseDetail?.sales[0]?.premiseType?.car ?? 0,
        fixEnergyCommissionValueByBike: isAdminAgency ? 0 : premiseDetail?.sales[0]?.premiseType?.bike ?? 0,
    }

    const initialValues = {
        ...premiseInfoInitial,
        ...premiseRentalPriceInitial,
        ...landlordCommissionInitial,
        hasSaleOrder: premiseDetail ? !!premiseDetail?.agencyId : false,
        isAdminAgency: isAdminAgency,
    };
    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: 'Danh sách mặt bằng',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    {
                        title: !premiseId
                            ? 'Tạo mặt bằng'
                            : 'Sửa mặt bằng'
                    },
                ])}
            </div>

            <div>
                {isReady ? (
                    <div className="m-4 mt-16">
                        {isDisabled && (
                            <div className="mb-4">
                                <CustomAlert
                                    icon="fa-regular fa-circle-info fa-2x"
                                    title={`Không thế thiết lập hoa hồng`}
                                    message={`Hoa hồng giới thiệu mặt bằng chỉ được thiết lập khi có đơn hàng giới thiệu ứng với mặt bằng này.`}
                                    bgColor="rgba(255, 246, 246, 1)"
                                />
                            </div>
                        )}
                        <AppTabs
                            tabs={tabs}
                            activeTab={selectedTab}
                            handleClick={handleSelectedTab}
                            additionalClassName="pl-0 mt-0 mr-3"
                            disabledTabs={disabledTabs}
                        />
                        <div
                            className={`bg-white p-4 rounded-bottom-lg rounded-right-lg`}
                        >
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                enableReinitialize={true}
                                noValidate
                                onSubmit={(values) => {
                                    console.log({ values });
                                }}
                            >
                                {(formikProps) => {
                                    refFormik.current = formikProps;

                                    return (
                                        <form onSubmit={formikProps.handleSubmit}>
                                            {selectedTab === t('Thông tin mặt bằng') && (
                                                <PremiseInfoView
                                                    formikProps={formikProps}
                                                    agencyRole={agencyRole}
                                                    premiseDetail={premiseDetail}
                                                    isAddSubAgency={isAddSubAgency}
                                                    adminRole={adminRole}
                                                    selectedAreaProvince={selectedAreaProvince}
                                                    setSelectedAreaProvince={setSelectedAreaProvince}
                                                    selectedAreaDistrict={selectedAreaDistrict}
                                                    setSelectedAreaDistrict={setSelectedAreaDistrict}
                                                    bankList={bankList}
                                                    commissionGrounds={commissionGrounds}
                                                    rentalForm={rentalForm}
                                                    setRentalForm={setRentalForm}
                                                    readyToValidData={readyToValidData}
                                                    setRentalPriceTypeDisabled={setRentalPriceTypeDisabled}
                                                />
                                            )}

                                            {selectedTab === t('Phí thuê mặt bằng') && (
                                                <PremiseRentalPriceView
                                                    formikProps={formikProps}
                                                    isRentalPriceTypeDisabled={isRentalPriceTypeDisabled}
                                                />
                                            )}

                                            {selectedTab === t('Hoa hồng giới thiệu mặt bằng') && (
                                                <LandlordCommissionView
                                                    formikProps={formikProps}
                                                    commissionGrounds={commissionGrounds}
                                                    isDisabled={isDisabled}
                                                />
                                            )}
                                        </form>
                                    );
                                }}
                            </Formik>
                        </div>
                    </div>
                ) : (
                    <div>Loading...</div>
                )}
            </div>
            <footer className="w-100 position-fixed bottom-0 end-0 bg-white py-3 shadow-sm">
                <div className="container-fluid px-4">
                    <div className="d-flex justify-content-end gap-2">
                        <Button
                            variant="secondary"
                            className="fw-bold"
                            style={{
                                fontSize: '13px',
                                color: AppColors.gray[800],
                                padding: '8px 16px',
                            }}
                            onClick={handleClose}
                        >
                            {t('Hủy bỏ')}
                        </Button>

                        <Button
                            variant="success"
                            className="fw-bold"
                            style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                            }}
                            onClick={handleSubmit}
                        >
                            {premiseDetail ? t('save') : t('Tạo mới')}
                        </Button>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default EditPremiseScreen;
